export const nonAvailableImg = {
    margin: "auto",
    display: "block !important"
};
export const noImg = {
    display: "flex",
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
};
